"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHandicap = isHandicap;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
function isHandicap(marketName) {
    return (marketName === betweb_openapi_axios_1.HotProbabilityMarketType.Handicap ||
        marketName === betweb_openapi_axios_1.HotProbabilityMarketType.HandicapWithOt);
}
//# sourceMappingURL=isHandicap.js.map